window.vela = window.vela || {};
window.money_format = vela.strings.moneyFormat;
vela.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

vela.Sections.prototype = _.assignIn({}, vela.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) {
      return;
    }
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;
      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});
vela.Disclosure = (function() {
  var selectors = {
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();
vela.Currency = (function() {
  var moneyFormat = '${{amount}}';
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      // Remove trailing zeros
      number = parseFloat(number).toString();
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  };
})();

if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}
ShopifyAPI.attributeToString = function(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

ShopifyAPI.onCartUpdate = function() {
  // When cart update
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + ShopifyAPI.attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var formData = new FormData(form);
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.getCart = function(callback, added) {
  jQuery.getJSON('/cart.js', function(cart) {
    if (typeof callback === 'function') {
      callback(cart, added);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest,cart) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          if (data.message) {
            if (data.status === 422) {
              var $toast = $('.ajaxcart-toast');
              $toast.find('.toast-body').html(data.description);
              $toast.toast('show');
            }
          }
          callback(cart);
    }
  };
  jQuery.ajax(params);
};

var ajaxCart = (function(module, $) {
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer;

  // Private functions
  var initializeEvents,
    updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartModalAdded,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    shippingBar,
    adjustCart,
    adjustCartCallback,
    validateQty;

  /*============================================================================
    Initialise the plugin and define global options
 ==============================================================================*/
  init = function(options) {
    // Default settings
    settings = {
      formSelector: '[data-product-form]',
      cartContainer: '[data-cart-container]',
      addToCartSelector: 'button[type="submit"]',
      cartCountSelector: '[data-cart-count]',
      cartCostSelector: '[data-cart-cost]',
      cartRemoveSelector: '[data-cart-remove]',
      headerCartSelector: '.js-header-cart',
      cartModalSelector: '.js-cart-modal',
      cartModalCloseSelector: '.js-cart-modal-close',
      moneyFormat: vela.strings.moneyFormat,
      disableAjaxCart: false,
      cartTemplate: '#ajaxcart-template',
      cartModalHeaderTemplate: '#ajaxcart-header-template'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    $body = $('body');
    isUpdating = false;
    initializeEvents();
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
    adjustCart();
  };

  initializeEvents = function() {
    $body.on('click', settings.cartModalCloseSelector, function() {
      $(settings.cartModalSelector).fadeOut(400, function() {
        $(this).remove();
      });
    });

    $body.on('click', settings.headerCartSelector, function(e) {
      if (vela.settings.cartType == 'modal' && $(window).width() > 767 && !$('body').hasClass('template-cart')) {
        e.preventDefault();
        return;
      }
    });

    $body.on('click', settings.cartRemoveSelector, function(e) {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line');
      if (line) {
        isUpdating = true;
        setTimeout(function() {
          ShopifyAPI.changeItem(line, 0, adjustCartCallback);
        }, 250);
      }
      setTimeout(function() {
        // Reinitialize swiper
        console.log("on removing button clickeddd");
        if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
          console.log('Reinitializing cart upsell swiper after cart adjustment...');
          vela.cartUpsellSwiper.init();
        }
        // Reinitialize toggle
        if (vela.shippingProtectionToggle && vela.shippingProtectionToggle.init) {
          console.log('Reinitializing shipping protection toggle after cart adjustment...');
          vela.shippingProtectionToggle.init();
        }
        // Reinitialize cart upsell products
        if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
          console.log('Updating cart upsell products after cart adjustment...');
          vela.cartUpsellProducts.updateUpsellProducts();
        }
      }, 5000);
    });

    $body.on('change', '.ajaxcart__note-input', function() {
      var newNote = $(this).val();
      ShopifyAPI.updateCartNote(newNote, function() {});
    });
    $body.on('change', '.coupon_code_input', function() {
			var newDiscount = $(this).val();
			vela.setCookie('vela_discount', newDiscount, 1);
		});
  };

  loadCart = function() {
    if($('.js-drawer').length > 0 || $('[data-cart-container]').length > 0 ) {
			$body.addClass('ajaxcart--is-loading');
		}
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count);
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        vela.Currency.formatMoney(cart.total_price, vela.strings.moneyFormat)
      );
    }
    
    // Show/hide footer buttons based on cart state
    var $footer = $('.drawer__footer');
    if (cart.item_count === 0) {
      $footer.css({opacity: 0, visibility: 'hidden'});
    } else {
      $footer.css({opacity: 1, visibility: 'visible'});
    }
    
    // Update individual line item prices including compare at price
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(function(cartItem, index) {
        var line = index + 1;
        var $lineItem = $('.ajaxcart__product[data-line="' + line + '"]');
        
        if ($lineItem.length > 0) {
          // Update the main price (line total price)
          var $priceElement = $lineItem.find('.ajaxcart__price:not(.ajaxcart__price--compare)');
          if ($priceElement.length > 0) {
            var linePrice = vela.Currency.formatMoney(
              cartItem.final_line_price || cartItem.original_line_price,
              vela.strings.moneyFormat
            );
            $priceElement.html(linePrice);
          }
          
          // Update compare at price if it exists
          var $comparePriceElement = $lineItem.find('.ajaxcart__price--compare');
          if ($comparePriceElement.length > 0) {
            // Scenario 3: Discount applied - use original price as compare at price
            if (cartItem.final_line_price !== cartItem.original_line_price) {
              var formattedComparePrice = vela.Currency.formatMoney(
                cartItem.original_line_price,
                vela.strings.moneyFormat
              );
              $comparePriceElement.html(formattedComparePrice);
            } else {
              // Scenario 1 & 2: No discount - check for product compare at price
              var variantId = cartItem.variant_id;
              var productHandle = cartItem.handle;
              
              // Fetch product details to get compare at price
              $.getJSON('/products/' + productHandle + '.js', function(product) {
                var compareAtPrice = null;
                
                if (product && product.variants) {
                  // Check variant compare at price
                  var variant = product.variants.find(function(v) { 
                    return v.id === variantId; 
                  });
                  if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
                    compareAtPrice = variant.compare_at_price;
                  }
                } else if (product && product.compare_at_price && product.compare_at_price > product.price) {
                  // Check product level compare at price for single products
                  compareAtPrice = product.compare_at_price;
                }
                
                if (compareAtPrice) {
                  // Scenario 2: No discount + Has compare at price
                  var compareAtPriceTotal = compareAtPrice * cartItem.quantity;
                  var formattedComparePrice = vela.Currency.formatMoney(
                    compareAtPriceTotal,
                    vela.strings.moneyFormat
                  );
                  $comparePriceElement.html(formattedComparePrice);
                }
                // Scenario 1: No discount + No compare at price - element will be empty
              });
            }
          }
          
          // Update discounted price if it exists
          var $discountedPriceElement = $lineItem.find('.ajaxcart__price--sale');
          if ($discountedPriceElement.length > 0 && cartItem.final_line_price !== cartItem.original_line_price) {
            var discountedPrice = vela.Currency.formatMoney(
              cartItem.final_line_price,
              vela.strings.moneyFormat
            );
            $discountedPriceElement.html(discountedPrice);
          }
        }
      });
    }
  };

  formOverride = function() {
    $body.on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();
       $addToCart.attr('disabled', 'disabled').prepend('<span class="spinner-border spinner-border-sm"></span>');
        $addToCart.removeClass('is-added').addClass('is-adding');
      $('.ajaxcart-toast').toast('hide');
			ShopifyAPI.addItemFromForm(evt.target,itemAddedCallback,itemErrorCallback);
    });
  };

  itemAddedCallback = function(lineItem) {
    $addToCart.removeAttr('disabled').find('.spinner-border').remove();
    $addToCart.removeClass('is-adding').addClass('is-added');
    if (vela.settings.cartType == 'modal') {
      cartModalAdded(lineItem);
    }
    ShopifyAPI.getCart(cartUpdateCallback, true);
  };

  itemErrorCallback = function(XMLHttpRequest) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeAttr('disabled').find('.spinner-border').remove();
    $addToCart.removeClass('is-adding is-added');

    if (data.message) {
      if (data.status === 422) {
        var $toast = $('.ajaxcart-toast');
        $toast.find('.toast-body').html(data.description);
        $toast.toast('show');
      }
    }
  };

  cartModalAdded = function(lineItem) {
    var data = {},
      image = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif',
      source = $(settings.cartModalHeaderTemplate).html(),
      template = Handlebars.compile(source);
    if (lineItem.image != null) {
      image = lineItem.image;
    }
    data = {
      name: lineItem.title,
      image: image,
      options: lineItem.options_with_values
    }
    $body.append(template(data));
    $('.js-cart-modal').fadeIn(400);
  };

  cartUpdateCallback = function(cart, added) {
    updateCountPrice(cart);
    buildCart(cart);
    if (added) {
      $body.trigger('drawer.open');
    }
    
    // Dispatch custom event for cart updates
    const cartUpdatedEvent = new CustomEvent('cart:updated', {
      detail: { cart: cart, added: added }
    });
    document.dispatchEvent(cartUpdatedEvent);
    
    console.log("cart updatee");
        // Update upsell product buttons after cart is built
        setTimeout(function() {
          if (typeof window.updateUpsellProductButtons === 'function') {
            console.log("update upsell buttons function called");
            window.updateUpsellProductButtons();
          }
          // Also update using the new module if available
          if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
            console.log("update upsell products module called");
            vela.cartUpsellProducts.updateUpsellProducts();
          }
        }, 2000);
  };
  
  // Make cart functions globally accessible
  vela.cartUpdateCallback = cartUpdateCallback;
  vela.updateCountPrice = updateCountPrice;
  vela.buildCart = buildCart;

  buildCart = function(cart) {
    $cartContainer.empty();
    if ( vela.settings.shippingBarEnable) {       
      shippingBar(cart);
    }
    // Show empty cart
    if (cart.item_count === 0) {
      // Hide footer buttons when cart is empty
      $('.drawer__footer').css({opacity: 0, visibility: 'hidden'});
      
      $cartContainer.append(
        '<p class="cart-empty-message">' +
          vela.strings.cartEmpty +
          '</p>\n' +
          '<p class="cookie-message">' +
          vela.strings.cartCookies +
          '</p>'
      );

      cartCallback(cart);
      return;
    }
    var items = [],
      item = {},
      data = {},
      source = $(settings.cartTemplate).html();

          var template = Handlebars.compile(source);

      // Function to fetch product details for compare at price
      var getProductDetails = function(handle, callback) {
        $.getJSON('/products/' + handle + '.js', function(product) {
          callback(product);
        }).fail(function() {
          callback(null);
        });
      };

      $.each(cart.items, function(index, cartItem) {
      var prodImg;
      var unitPrice = null;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = vela.Currency.formatMoney(
            amount,
            vela.strings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = vela.Currency.formatMoney(
            cartAmount,
            vela.strings.moneyFormat
          );
        }
      }

      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue:
            cartItem.unit_price_measurement.reference_value !== 1,
          price: vela.Currency.formatMoney(
            cartItem.unit_price,
            vela.strings.moneyFormat
          ),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit
        };
      }
      
      // The point where cart update
      // console.log("cartItem: ", cartItem);

             // Fetch product details and create item object
       getProductDetails(cartItem.handle, function(product) {
        //  console.log("Product details for", cartItem.handle, ":", product);
         
         var cartItemCompareAtPrice = null;
         if (product && product.variants) {
           var variant = product.variants.find(function(v) { 
             return v.id === cartItem.variant_id; 
           });
           if (variant) {
            //  console.log("Variant found:", variant);
            //  console.log("Compare at price:", variant.compare_at_price);
             cartItemCompareAtPrice = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : null;
           }
         } else if (product && product.compare_at_price) {
           // Handle single product with no variants - check product level compare at price
           cartItemCompareAtPrice = (product.compare_at_price && product.compare_at_price > product.price) ? product.compare_at_price : null;
         }

         // Create item's data object and add to 'items' array
         var item = {
           key: cartItem.key,
           line: index + 1, // Shopify uses a 1+ index in the API
           url: cartItem.url,
           img: prodImg,
           name: cartItem.product_title,
           prodHandle: cartItem.handle,
           variation: cartItem.variant_title === null ? false : true,
           variant: cartItem.variant,
           options: cartItem.options_with_values,
           variant_id: cartItem.variant_id,
           properties: cartItem.properties,
           itemAdd: cartItem.quantity + 1,
           itemMinus: cartItem.quantity - 1,
           itemQty: cartItem.quantity,
           price: vela.Currency.formatMoney(
             cartItem.original_line_price,
             vela.strings.moneyFormat
           ),
           // Compare at price logic for three scenarios:
           // 1. No discount + No compare at price: null (show only simple price)
           // 2. No discount + Has compare at price: use product's compare at price
           // 3. Has discount + Has compare at price: use original price (before discount)
           compareAtPrice: (cartItem.final_line_price !== cartItem.original_line_price) ? 
             // Scenario 3: Discount applied - use original price as compare at price
             vela.Currency.formatMoney(cartItem.original_line_price, vela.strings.moneyFormat) : 
             // Scenario 1 & 2: No discount - use product's compare at price if it exists
             ((cartItemCompareAtPrice && cartItemCompareAtPrice > 0) ? 
               vela.Currency.formatMoney(cartItemCompareAtPrice * cartItem.quantity, vela.strings.moneyFormat) : 
               null),
           discountedPrice: vela.Currency.formatMoney(
             cartItem.final_line_price,
             vela.strings.moneyFormat
           ),
           discounts: cartItem.line_level_discount_allocations,
           discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
           vendor: cartItem.vendor,
           unitPrice: unitPrice
         };

         console.log("item: ", item);
         items.push(item);
        // if (cartItem.handle !== 'shiptection-shipping-protection') {
        //   items.push(item);
        // }
         
         // Check if all items have been processed
         if (items.length === cart.items.length) {
           // All items processed, render the cart
           renderCart();
         }
       });
    });

    // Function to render the cart once all product details are fetched
    var renderCart = function() {
      // Gather all cart data and add to DOM
    // Calculate original subtotal (before discounts)
    var originalSubtotal = cart.total_price;
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
        originalSubtotal += cart.cart_level_discount_applications[i].total_allocated_amount;
      }
    }
    
    // Format discount data for the template
    var formattedDiscounts = [];
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
        var discount = cart.cart_level_discount_applications[i];
        formattedDiscounts.push({
          title: discount.title,
          total_allocated_amount: vela.Currency.formatMoney(
            discount.total_allocated_amount,
            vela.strings.moneyFormat
          )
        });
      }
    }
    
    data = {
      items: items,
      note: cart.note,
      subtotalPrice: vela.Currency.formatMoney(
        originalSubtotal,
        vela.strings.moneyFormat
      ),
      totalPrice: vela.Currency.formatMoney(
        cart.total_price,
        vela.strings.moneyFormat
      ),
      cartDiscounts: formattedDiscounts,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true
    };
    $cartContainer.append(template(data));
    console.log("ConsoleData: ", data);
    document.querySelector('[data-cart-total]').textContent = data.totalPrice;
    
    // Show footer buttons when cart has items
    $('.drawer__footer').css({opacity: 1, visibility: 'visible'});
    
    cartCallback(cart);
    var discount_code = vela.getCookie('vela_discount');
    if( discount_code ) {
      $(".js-drawer .coupon_code_input").val(discount_code);
    }
    var gift_proHandle = $(".ajaxcart__gift--button").data("prohandle");
    $.each(data.items, function() {
      $.each(this, function( index , value) {
        if(( index == "prodHandle" && value == gift_proHandle )) {
          $(".ajaxcart__gift--button").addClass("d-none");
        }
      });
    });
    
          $('.pre_order-cart >span').each(function(){
        var preOrder_prohandle = $(this).data('handle');
        $.each(data.items, function( index , value) {
          if(value.prodHandle == preOrder_prohandle ) {
            $('.ajaxcart__product[data-line="'+ value.line + '"] .pro_preorder').removeClass('d-none');
          }
        });
      });
    };

    setTimeout(function() {
      // Reinitialize cart upsell progress bar
      console.log("on removing button clickeddd");
      if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
        console.log('Reinitializing cart upsell progress bar after cart adjustment...');
        vela.cartUpsellSwiper.init();
      }
      // Reinitialize toggle
      if (vela.shippingProtectionToggle && vela.shippingProtectionToggle.init) {
        console.log('Reinitializing shipping protection toggle after cart adjustment...');
        vela.shippingProtectionToggle.init();
      }
      // Reinitialize cart upsell products
      if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
        console.log('Updating cart upsell products after cart adjustment...');
        vela.cartUpsellProducts.updateUpsellProducts();
      }
    }, 5000);
  };
  shippingBar = function(cart) {  
    var shipping_value = $('.shipping-bar-cart').data('shipping_value');
    if( (shipping_value > cart.total_price) && shipping_value != 0){
      var minus_spend = shipping_value - cart.total_price;
      var spend = vela.Currency.formatMoney(minus_spend,settings.moneyFormat);
      var percent	= cart.total_price/shipping_value*100;
      $('.shipping-bar-cart .title-spend .spend').html(spend);
      $('.shipping-bar-cart .progress-bar').css("width",percent+"%");
      if (cart.item_count === 0) {
        $('.shipping-bar-cart').removeClass('shipping-progress');
        $('.shipping-bar-cart').removeClass('shipping-free');
      } else {
        $('.shipping-bar-cart').removeClass('shipping-free');
        $('.shipping-bar-cart').addClass('shipping-progress');
      }
    }else {
      $('.shipping-bar-cart').addClass('shipping-free');
      $('.shipping-bar-cart').addClass('effect');
      $('.shipping-bar-cart').removeClass('shipping-progress');
      $('.shipping-bar-cart .progress-bar').css("width","100%");
      setTimeout(function() {
        $('.shipping-bar-cart').removeClass('effect');
      },5000);
    }
  };
  cartCallback = function(cart) {
    $body.removeClass('ajaxcart--is-loading');
    $body.trigger("ajaxCart.afterCartLoad", cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    $body.trigger('drawer.footer');
  };

  adjustCart = function() {
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      if (line) {
        updateQuantity(line, qty);
      }
    });

    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      var $row = $('.ajaxcart__product[data-line="' + line + '"]').addClass(
        'is-loading'
      );

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
  };

  adjustCartCallback = function(cart) {
    updateCountPrice(cart);
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      qty = 1;
    }
    return qty;
  };
  
  module = {
    init: init,
    load: loadCart
  };

  return module;

})(ajaxCart || {}, jQuery);

vela.cartUpsellSwiper = (function(module) {
  var init, logWrapper, setupScrollProgress, updateScrollProgress, calculateInitialProgress, setupArrowNavigation, scrollToPosition, updateArrowStates;

  init = function() {
    // console.log('Cart upsell progress bar module initialized');
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', logWrapper);
    } else {
      logWrapper();
    }

    $('body').on('drawer.open', function() {
      console.log("Drawer opened - initializing slider progress bar");
      // Small delay to ensure DOM is ready
      setTimeout(function() {
        logWrapper();
      }, 1000);
    });
  };

  logWrapper = function() {
    const wrapper = document.querySelector('.cart-upsell-slider');
    // console.log('Cart upsell slider element:', wrapper);
    
    if (wrapper) {
      // console.log('Wrapper found with classes:', wrapper.className);
      // console.log('Wrapper children count:', wrapper.children.length);
      
      // Set up scroll progress tracking
      setupScrollProgress(wrapper);
      // Set up arrow navigation
      setupArrowNavigation(wrapper);
    } else {
      console.log('No cart-upsell-slider element found');
    }
  };

  setupScrollProgress = function(wrapper) {
    const progressFill = document.querySelector('.drawer-upsell-progress-fill');
    
    if (!progressFill) {
      // console.log('Progress bar fill element not found');
      return;
    }

    // Update progress on scroll
    wrapper.addEventListener('scroll', function() {
      updateScrollProgress(wrapper, progressFill);
      updateArrowStates(wrapper);
    });

    // Wait a bit for layout to settle, then update initial progress
    setTimeout(function() {
      updateScrollProgress(wrapper, progressFill);
      updateArrowStates(wrapper);
    }, 100);
    
    console.log('Scroll progress tracking set up successfully');
  };

  setupArrowNavigation = function(wrapper) {
    const prevArrow = document.querySelector('.cart-upsell-arrow--prev');
    const nextArrow = document.querySelector('.cart-upsell-arrow--next');
    
    if (!prevArrow || !nextArrow) {
      console.log('Arrow navigation elements not found');
      return;
    }

    // Previous arrow click handler
    prevArrow.addEventListener('click', function() {
      const scrollAmount = wrapper.clientWidth * 0.8; // Scroll 80% of visible width
      const newScrollLeft = Math.max(0, wrapper.scrollLeft - scrollAmount);
      scrollToPosition(wrapper, newScrollLeft);
    });

    // Next arrow click handler
    nextArrow.addEventListener('click', function() {
      const scrollAmount = wrapper.clientWidth * 0.8; // Scroll 80% of visible width
      const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
      const newScrollLeft = Math.min(maxScrollLeft, wrapper.scrollLeft + scrollAmount);
      scrollToPosition(wrapper, newScrollLeft);
    });

    // Initial arrow state update
    updateArrowStates(wrapper);
    
    // console.log('Arrow navigation set up successfully');
  };

  scrollToPosition = function(wrapper, scrollLeft) {
    wrapper.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };

  updateArrowStates = function(wrapper) {
    const prevArrow = document.querySelector('.cart-upsell-arrow--prev');
    const nextArrow = document.querySelector('.cart-upsell-arrow--next');
    
    if (!prevArrow || !nextArrow) return;

    const scrollLeft = wrapper.scrollLeft;
    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
    const tolerance = 1; // Small tolerance for floating point precision
    
    // Update previous arrow state
    if (scrollLeft <= tolerance) {
      prevArrow.disabled = true;
    } else {
      prevArrow.disabled = false;
    }
    
    // Update next arrow state
    if (scrollLeft >= (maxScrollLeft - tolerance)) {
      nextArrow.disabled = true;
    } else {
      nextArrow.disabled = false;
    }
    
    // console.log('Arrow states updated - scrollLeft:', scrollLeft, 'maxScrollLeft:', maxScrollLeft, 'prev disabled:', prevArrow.disabled, 'next disabled:', nextArrow.disabled);
  };

  updateScrollProgress = function(wrapper, progressFill) {
    const scrollLeft = wrapper.scrollLeft;
    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    // console.log("scrollLeft: ", scrollLeft);
    // console.log("maxScrollLeft: ", maxScrollLeft);
    // console.log("clientWidth: ", clientWidth);
    // console.log("scrollWidth: ", scrollWidth);
    // console.log("totalProducts: ", totalProducts);
    // Check if scrolling is possible
    if (scrollWidth > clientWidth) {
      // Calculate initial progress (how many products are viewable)
      const initialProgress = calculateInitialProgress(wrapper);

      if (scrollLeft > 0) {
        // User is scrolling - calculate progress from initial position
        const scrollProgress = (scrollLeft / maxScrollLeft) * (100 - initialProgress);
        const totalProgress = initialProgress + scrollProgress;
        
        progressFill.style.width = totalProgress + '%';
      } else {
        // At the beginning - show initial progress
        progressFill.style.width = initialProgress + '%';
      }
    } else {
      // No scrolling needed, all content is visible
      progressFill.style.width = '100%';
    }
  };

  calculateInitialProgress = function(wrapper) {
    const clientWidth = wrapper.clientWidth;
    const scrollWidth = wrapper.scrollWidth;
    const totalProducts = wrapper.children.length;
    
    if (totalProducts === 0) return 0;
    
    // Calculate how many products are currently viewable
    const viewableProducts = clientWidth / (scrollWidth / totalProducts);
    
    // Calculate initial progress (how much of the total scrollable area is initially visible)
    const initialProgress = (viewableProducts / totalProducts) * 100;
    
    // console.log("initialProgress: ", initialProgress);
    // console.log("viewableProducts: ", viewableProducts);
    // Cap the progress at 100%
    return Math.min(initialProgress, 100);
  };

  module = {
    init: init
  };

  return module;
})();

vela.drawerCart = (function(module) {
  var $body, $drawer, drawerCloseSelector, headerCartSelector, drawerIsOpen;

  var init, drawerOpen, drawerClose, drawerFooter;

  var classes = {
    open: 'drawer--open'
  };

  init = function() {
    $body = $('body');
    $drawer = $('.js-drawer');
    drawerCloseSelector = '.js-drawer-close';
    headerCartSelector = '.js-header-cart';
    drawerIsOpen = false;

    $body.on('drawer.open', function(evt) {
      drawerOpen(evt);
    });

    $body.on('drawer.close', function(evt) {
      drawerClose(evt);
    });

    $body.on('drawer.footer', function() {
      drawerFooter();
    });

    $body.on('click', headerCartSelector, function(evt) {
      evt.preventDefault();
      $body.trigger('drawer.open', evt);
    });

    $body.on('click', drawerCloseSelector, function(evt) {
      evt.preventDefault();
      $body.trigger('drawer.close', evt);
    });
  };

  drawerOpen = function(evt) {
    if (drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    $body.addClass(classes.open);
    drawerIsOpen = true;
  };

  drawerClose = function(evt) {
    if (!drawerIsOpen) {
      return;
    }

    if (evt.keyCode !== 27) {
      evt.preventDefault();
    }

    $body.removeClass(classes.open);
    drawerIsOpen = false;
  };

  drawerFooter = function() {
    if (!$drawer.hasClass('drawer--has-fixed-footer')) {
      return;
    }
    
      var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
    var $cartInner = $('.ajaxcart__inner').removeAttr('style');
    var cartFooterHeight = Math.round($cartFooter.outerHeight());
    $('.drawer__inner').css('top', ( $('.drawer__header').outerHeight() + 15));
    $cartInner.css('bottom', cartFooterHeight);
    $cartFooter.css('height', cartFooterHeight);
    
    if(vela.settings.shippingCalcEnable && $cartFooter.hasClass('border-top')) {
      Shopify.Cart.ShippingCalculator.show( {
        submitButton: vela.settings.shippingCalcSubmitButton,
        submitButtonDisabled: vela.settings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: vela.settings.shippingCalcCustomerIsLoggedIn,
        moneyFormat: vela.strings.shop_money_with_currency_format
      });
    }
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
  };

  module = {
    init: init
  }

  return module;
})();

vela.shippingProtectionToggle = (function(module) {
  var shippingProtectionToggle = null;

  var init, initToggle, destroyToggle;

  init = function() {
    console.log("Shipping protection toggle module initialized");
    
    // Listen for drawer open event to initialize shipping protection toggle
    $('body').on('drawer.open', function() {
      console.log("Drawer opened - initializing shipping protection toggle");
      // Small delay to ensure DOM is ready
      setTimeout(function() {
        initToggle();
      }, 1000);
    });

    // Listen for drawer close event to cleanup
    $('body').on('drawer.close', function() {
      console.log("Drawer closed - cleaning up shipping protection toggle");
      destroyToggle();
    });

    // Listen for cart updates to re-initialize shipping protection toggle and cart upsell progress bar
    $('body').on('cart:updated', function() {
      console.log("Cart updated - re-initializing components...");
      setTimeout(function() {
        // Reinitialize cart upsell progress bar
        if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
          console.log("Reinitializing cart upsell progress bar...");
          vela.cartUpsellSwiper.init();
        }
        // Reinitialize toggle
        initToggle();
        // Update cart upsell products
        if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
          console.log("Updating cart upsell products...");
          vela.cartUpsellProducts.updateUpsellProducts();
        }
      }, 100);
    });

    // Listen for cart content changes
    $('body').on('cart:content-updated', function() {
      console.log("Cart content updated - re-initializing components...");
      setTimeout(function() {
        // Reinitialize cart upsell progress bar
        if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
          console.log("Reinitializing cart upsell progress bar...");
          vela.cartUpsellSwiper.init();
        }
        // Reinitialize toggle
        initToggle();
        // Update cart upsell products
        if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
          console.log("Updating cart upsell products...");
          vela.cartUpsellProducts.updateUpsellProducts();
        }
      }, 100);
    });
    
    // Also try to initialize on DOM ready as a fallback
    $(document).ready(function() {
      setTimeout(function() {
        if (document.querySelector('#shipping-protection-toggle')) {
          console.log("Shipping protection toggle found on DOM ready, initializing...");
          initToggle();
        }
      }, 500);
    });
    
    // Additional fallback: check for toggle availability and initialize
    var checkToggleAndInit = function() {
      if (document.querySelector('#shipping-protection-toggle')) {
        // console.log("Shipping protection toggle found, initializing...");
        initToggle();
      } else {
        // console.log("Shipping protection toggle not found, retrying...");
        setTimeout(checkToggleAndInit, 200);
      }
    };
    
    // Start checking for toggle availability
    setTimeout(checkToggleAndInit, 100);
  };

  initToggle = function() {
    const toggleElement = document.querySelector('#shipping-protection-toggle');
    console.log("🔧 Toggle initialize again");
    if (toggleElement && !shippingProtectionToggle) {
      try {
        console.log("🚀 Initializing shipping protection toggle...");
        
        // Check if toggle is already initialized
        if (toggleElement.hasAttribute('data-shipping-protection-initialized')) {
          console.log("✅ Shipping protection toggle already initialized");
          return;
        }
        
        // Mark as initialized
        toggleElement.setAttribute('data-shipping-protection-initialized', 'true');
        
        // Get variant ID from data attribute
        const variantId = toggleElement.getAttribute('data-variant-id');
        console.log("🔍 Variant ID from attribute:", variantId);
        
        // Check localStorage for saved state
        const savedState = localStorage.getItem('shipping-protection-toggle-state');
        console.log("💾 Saved state from localStorage:", savedState);
        
        // Check if toggle has checked attribute
        const hasCheckedAttribute = toggleElement.hasAttribute('checked');
        const checkedAttributeValue = toggleElement.getAttribute('checked');
        // console.log("🔍 Toggle has checked attribute:", hasCheckedAttribute, "Value:", checkedAttributeValue);
        
        // Determine initial state priority: localStorage > checked attribute > default false
        let initialState = false;
        if (savedState !== null) {
          initialState = savedState === 'true';
          // console.log("📱 Using saved state from localStorage:", initialState);
        } else if (hasCheckedAttribute && checkedAttributeValue !== null) {
          initialState = checkedAttributeValue === 'true' || checkedAttributeValue === '';
          // console.log("📱 Using checked attribute value:", initialState);
        } else {
          console.log("📱 Using default state: false");
        }
        
        // Set the toggle state using the helper function
        forceUpdateToggleState(toggleElement, initialState);
        
        // Check current cart status
        checkCurrentStatus(toggleElement, variantId);
        
        // Ensure toggle state is properly synchronized after cart check
        setTimeout(() => {
          const currentState = getShippingProtectionState();
          if (currentState !== null) {
            forceUpdateToggleState(toggleElement, currentState);
          }
        }, 100);
        
        // console.log("Shipping protection toggle initialized successfully");
        
      } catch (error) {
        console.error('Error initializing shipping protection toggle:', error);
      }
    } else if (shippingProtectionToggle) {
      console.log("Shipping protection toggle already exists");
    } else {
      console.log("Shipping protection toggle element not found");
    }
  };

  handleToggleChange = async function(event) {
    const toggle = event.target;
    const isChecked = toggle.checked;
    
    console.log('=== SHIPPING PROTECTION TOGGLE CHANGE ===');
    console.log('Toggle element:', toggle);
    console.log('Is checked:', isChecked);
    console.log('Toggle disabled:', toggle.disabled);
    
    if (toggle.disabled) {
      console.log('Toggle is disabled, ignoring change');
      return;
    }
    
    // Save the current state to localStorage immediately
    localStorage.setItem('shipping-protection-toggle-state', isChecked.toString());
    console.log('💾 State saved to localStorage:', isChecked);
    
    if (isChecked) {
      toggle.setAttribute("checked", "checked");
      console.log('Adding shipping protection...');
      // Get the variant ID from getShippingVariantId function
      try {
        const variantData = await getShippingVariantId();
        if (variantData && variantData.variantId) {
          console.log('✅ Got variant ID from getShippingVariantId:', variantData.variantId);
          addShippingProtection(toggle, variantData.variantId);
        } else {
          console.error('❌ No variant ID found from getShippingVariantId');
          showMessage('Failed to get shipping protection variant', 'error');
          toggle.checked = false; // Revert toggle state
          toggle.removeAttribute('checked'); // Remove checked attribute
          // Update localStorage to reflect the reverted state
          localStorage.setItem('shipping-protection-toggle-state', 'false');
        }
      } catch (error) {
        console.error('❌ Error getting variant ID:', error);
        showMessage('Failed to get shipping protection variant', 'error');
        toggle.checked = false; // Revert toggle state
        toggle.removeAttribute('checked'); // Remove checked attribute
        // Update localStorage to reflect the reverted state
        localStorage.setItem('shipping-protection-toggle-state', 'false');
      }
    } else {
      console.log('Removing shipping protection...');
      // For removal, we still need a variant ID - get it from the function
      toggle.removeAttribute("checked");
      try {
        const variantData = await getShippingVariantId();
        if (variantData && variantData.variantId) {
          console.log('✅ Got variant ID for removal:', variantData.variantId);
          removeShippingProtection(toggle, variantData.variantId);
        } else {
          console.error('❌ No variant ID found for removal');
          showMessage('Failed to get shipping protection variant for removal', 'error');
          toggle.checked = true; // Revert toggle state
          toggle.setAttribute('checked', 'checked'); // Add checked attribute
          // Update localStorage to reflect the reverted state
          localStorage.setItem('shipping-protection-toggle-state', 'true');
        }
      } catch (error) {
        console.error('❌ Error getting variant ID for removal:', error);
        showMessage('Failed to get shipping protection variant for removal', 'error');
        toggle.checked = true; // Revert toggle state
        toggle.setAttribute('checked', 'checked'); // Add checked attribute
        // Update localStorage to reflect the reverted state
        localStorage.setItem('shipping-protection-toggle-state', 'true');
      }
    }
  };

  async function addShippingProtection(toggle, variantId) {
    // console.log('=== ADDING SHIPPING PROTECTION ===');
    // console.log('Toggle element:', toggle);
    // console.log('Variant ID:', variantId);
    // console.log('Toggle disabled:', toggle.disabled);
    
    if (toggle.disabled) {
      console.log('Toggle is disabled, cannot add shipping protection');
      return;
    }
    
    console.log('Setting loading state...');
    setLoading(toggle, true);
    
    try {
      console.log('Making API call to add shipping protection...');
      const requestBody = {
        id: Number(variantId),
        quantity: 1
      };
      console.log('Request body:', requestBody);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      console.log('API response status:', response.status);
      console.log('API response ok:', response.ok);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Shipping protection added successfully:', result);
      
      // Reinitialize cart upsell progress bar and toggle after cart update
      // console.log('Reinitializing components after adding shipping protection...');
      setTimeout(function() {
        // Reinitialize cart upsell progress bar
        if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
          console.log('Reinitializing cart upsell progress bar...');
          vela.cartUpsellSwiper.init();
        }
        // Reinitialize toggle
        initToggle();
        // Update cart upsell products
        if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
          console.log('Updating cart upsell products...');
          vela.cartUpsellProducts.updateUpsellProducts();
        }
      }, 200);
      
      // Show success message
      showMessage('Shipping protection added to cart', 'success');
      
    } catch (error) {
      console.error('=== ERROR ADDING SHIPPING PROTECTION ===');
      console.error('Error details:', error);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      
      // Revert toggle state on error
      console.log('Reverting toggle state due to error...');
      toggle.checked = false;
      
      // Show error message
      showMessage('Failed to add shipping protection', 'error');
    } finally {
      console.log('Clearing loading state...');
      setLoading(toggle, false);
    }
  }

  async function removeShippingProtection(toggle, variantId) {
    // console.log('=== REMOVING SHIPPING PROTECTION ===');
    // console.log('Toggle element:', toggle);
    // console.log('Variant ID:', variantId);
    // console.log('Toggle disabled:', toggle.disabled);
    
    if (toggle.disabled) {
      console.log('Toggle is disabled, cannot remove shipping protection');
      return;
    }
    
    console.log('Setting loading state...');
    setLoading(toggle, true);
    
    try {
      console.log('Getting current cart to find shipping protection item...');
      // First, get the current cart to find the line item
      const cartResponse = await fetch('/cart.js');
      console.log('Cart response status:', cartResponse.status);
      
      if (!cartResponse.ok) {
        throw new Error(`HTTP error! status: ${cartResponse.status}`);
      }
      
      const cart = await cartResponse.json();
      // console.log('Current cart:', cart);
      // console.log('Cart items:', cart.items);
      
      // Find the shipping protection item
      const shippingProtectionItem = cart.items.find(item => 
        item.variant_id === variantId
      );
      
      console.log('Found shipping protection item:', shippingProtectionItem);
      console.log('Shipping protection item key:', shippingProtectionItem.key);
      console.log('Shipping protection item variant_id:', shippingProtectionItem.variant_id);
      
      if (!shippingProtectionItem) {
        console.warn('Shipping protection item not found in cart');
        console.log('Reverting toggle state to checked');
        toggle.checked = true;
        setLoading(toggle, false);
        return;
      }
      
      console.log('Making API call to remove shipping protection...');
      // Remove the item by setting quantity to 0 using line item key
      const requestBody = {
        id: shippingProtectionItem.key,
        quantity: 0
      };
      console.log('Request body:', requestBody);
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: shippingProtectionItem.key,
          quantity: 0
        })
      });

      console.log('API response status:', response.status);
      console.log('API response ok:', response.ok);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Shipping protection removed successfully:', result);
      
      // Reinitialize cart upsell progress bar and toggle after cart update
      console.log('Reinitializing components after removing shipping protection...');
      setTimeout(function() {
        // Reinitialize cart upsell progress bar
        if (vela.cartUpsellSwiper && vela.cartUpsellSwiper.init) {
          console.log('Reinitializing cart upsell progress bar...');
          vela.cartUpsellSwiper.init();
        }
        // Reinitialize toggle
        initToggle();
        // Update cart upsell products
        if (vela.cartUpsellProducts && vela.cartUpsellProducts.updateUpsellProducts) {
          console.log('Updating cart upsell products...');
          vela.cartUpsellProducts.updateUpsellProducts();
        }
      }, 200);
      
      // Show success message
      showMessage('Shipping protection removed from cart', 'success');
      
    } catch (error) {
      console.error('=== ERROR REMOVING SHIPPING PROTECTION ===');
      console.error('Error details:', error);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      
      // Revert toggle state on error
      console.log('Reverting toggle state due to error...');
      toggle.checked = true;
      
      // Show error message
      showMessage('Failed to remove shipping protection', 'error');
    } finally {
      console.log('Clearing loading state...');
      setLoading(toggle, false);
    }
  }

  async function checkCurrentStatus(toggle, variantId) {
    console.log('=== CHECKING CURRENT STATUS ===');
    console.log('Toggle element:', toggle);
    console.log('Variant ID:', variantId);
    setTimeout(function(){
      getShippingVariantId();
    }, 5000);
    
    try {
      console.log('Fetching current cart...');
      const response = await fetch('/cart.js');
      console.log('Cart response status:', response.status);
      
      if (!response.ok) {
        console.log('Cart response not ok, returning');
        return;
      }
      
      const cart = await response.json();
      // console.log('Current cart:', cart);
      // console.log('Cart items:', cart.items);
      
      // Check if shipping protection is already in cart
      const hasShippingProtection = cart.items.some(item => 
        item.variant_id.toString() === variantId
      );
      
      // console.log('Has shipping protection in cart:', hasShippingProtection);
      console.log('Current toggle state before update:', toggle.checked);
      
      // Update toggle state without triggering the change event
      // console.log('Removing event listener to prevent change event...');
      toggle.removeEventListener('change', handleToggleChange);
      
      // console.log('Setting toggle state to:', hasShippingProtection);
      toggle.checked = hasShippingProtection;
      
      // console.log('Re-adding event listener...');
      toggle.addEventListener('change', handleToggleChange);
      
      // console.log('Final toggle state:', toggle.checked);
      
    } catch (error) {
      console.error('=== ERROR CHECKING CART STATUS ===');
      console.error('Error details:', error);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
    }
  }

  function setLoading(toggle, loading) {
    toggle.disabled = loading;
    
    // Add loading class to parent container
    const container = toggle.closest('.ajaxcart__switch-toggle');
    if (container) {
      if (loading) {
        container.classList.add('loading');
      } else {
        container.classList.remove('loading');
      }
    }
  }

  function showMessage(message, type = 'info') {
    // Create toast notification
    const toast = document.createElement('div');
    toast.className = `shipping-protection-toast toast-${type}`;
    toast.innerHTML = `
      <div class="toast-content">
        <span class="toast-message">${message}</span>
        <button class="toast-close" onclick="this.parentElement.parentElement.remove()">×</button>
      </div>
    `;
    
    // Add to page
    document.body.appendChild(toast);
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      if (toast.parentElement) {
        toast.remove();
      }
    }, 3000);
  }

  /**
   * Clear shipping protection toggle state from localStorage
   * Useful for resetting the toggle state
   */
  function clearShippingProtectionState() {
    localStorage.removeItem('shipping-protection-toggle-state');
    console.log('🗑️ Shipping protection toggle state cleared from localStorage');
  }

  /**
   * Get current shipping protection toggle state from localStorage
   * @returns {boolean|null} The saved state or null if not found
   */
  function getShippingProtectionState() {
    const savedState = localStorage.getItem('shipping-protection-toggle-state');
    return savedState !== null ? savedState === 'true' : null;
  }

  /**
   * Force update toggle visual state and attributes
   * Ensures the toggle's visual appearance matches its logical state
   * @param {Element} toggle - The toggle element
   * @param {boolean} state - The desired state
   */
  function forceUpdateToggleState(toggle, state) {
    if (!toggle) return;
    
    // Remove event listener temporarily to prevent change events
    toggle.removeEventListener('change', handleToggleChange);
    
    // Update both the checked property and HTML attribute
    toggle.checked = state;
    if (state) {
      toggle.setAttribute('checked', 'checked');
    } else {
      toggle.removeAttribute('checked');
    }
    
    // Force a visual update by triggering a custom event
    const updateEvent = new Event('input', { bubbles: true });
    toggle.dispatchEvent(updateEvent);
    
    // Re-add event listener
    toggle.addEventListener('change', handleToggleChange);
    
    // console.log(`🔄 Toggle state force updated to: ${state}`);
    // console.log(`🔄 Toggle checked property: ${toggle.checked}`);
    // console.log(`🔄 Toggle has checked attribute: ${toggle.hasAttribute('checked')}`);
  }

  /**
   * Helper function to wait for shiptection widget to appear
   * 
   * This function uses a simple polling approach to detect when the shiptection widget
   * is dynamically loaded by the app:
   * 
   * 1. Immediate check: In case the widget is already there
   * 2. Polling: Checks every 500ms until found or timeout
   * 
   * @param {number} maxWaitTime - Maximum time to wait in milliseconds (default: 30s)
   * @returns {Promise<Element>} Promise that resolves with the widget element
   */
  function waitForShiptectionWidget(maxWaitTime = 30000) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      
      // Strategy 1: Immediate check
      const existingWidget = document.querySelector(".shiptection-widget");
      if (existingWidget) {
        // console.log("✅ Shiptection widget already exists");
        resolve(existingWidget);
        return;
      }
      
      // Strategy 2: Polling with timeout
      const pollInterval = setInterval(() => {
        const widget = document.querySelector(".shiptection-widget");
        if (widget) {
          // console.log("✅ Shiptection widget found via polling");
          clearInterval(pollInterval);
          resolve(widget);
          return;
        }
        
        // Check if we've exceeded max wait time
        if (Date.now() - startTime > maxWaitTime) {
          // console.warn("⏰ Max wait time exceeded for shiptection widget");
          clearInterval(pollInterval);
          reject(new Error("Shiptection widget not found within timeout"));
        }
      }, 500); // Check every 500ms
    });
  }

  // Helper function to wait for the data attribute to be populated
  function waitForShiptectionValue(widget, maxWaitTime = 10000) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      
      const checkValue = () => {
        const element = widget.querySelector("[data-shiptection-value]");
        if (element && element.getAttribute("data-shiptection-value")) {
          // console.log("✅ Shiptection value found");
          resolve(element);
          return;
        }
        
        // Check if we've exceeded max wait time
        if (Date.now() - startTime > maxWaitTime) {
          // console.warn("⏰ Max wait time exceeded for shiptection value");
          reject(new Error("Shiptection value not populated within timeout"));
          return;
        }
        
        // Check again in 200ms
        setTimeout(checkValue, 200);
      };
      
      checkValue();
    });
  }

  // Initialize shiptection widget detection
  function initShiptectionDetection() {
    // console.log("🚀 Initializing shiptection widget detection...");
    
    // Start watching for the widget immediately
    waitForShiptectionWidget()
      .then(widget => {
        // console.log("🎯 Shiptection widget detected, ready for use");
        // You can emit a custom event here if needed
        document.dispatchEvent(new CustomEvent('shiptection:ready', { detail: { widget } }));
      })
      .catch(error => {
        console.warn("⚠️ Shiptection widget detection failed:", error.message);
      });
  }

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShiptectionDetection);
  } else {
    initShiptectionDetection();
  }

  /**
   * More flexible element detection function
   * 
   * This is a generic function that can wait for any element to appear in the DOM.
   * Uses only polling and timeout - no MutationObserver.
   * It's useful for detecting dynamically loaded elements from apps, widgets, etc.
   * 
   * @param {string} selector - CSS selector for the element to wait for
   * @param {Object} options - Configuration options
   * @param {number} options.maxWaitTime - Maximum time to wait in milliseconds (default: 30s)
   * @param {number} options.checkInterval - How often to check for the element (default: 500ms)
   * @param {boolean} options.checkImmediately - Whether to check immediately (default: true)
   * @param {Function} options.onFound - Callback when element is found
   * @param {Function} options.onTimeout - Callback when timeout occurs
   * @returns {Promise<Element>} Promise that resolves with the found element
   * 
   * @example
   * // Wait for a widget to appear
   * const widget = await waitForElement('.my-widget', {
   *   maxWaitTime: 15000,
   *   onFound: (el) => console.log('Widget found:', el)
   * });
   * 
   * // Wait for a specific attribute to be populated
   * const element = await waitForElement('[data-value]', {
   *   checkImmediately: false, // Don't check immediately since we need the attribute
   *   onTimeout: () => console.log('Attribute never populated')
   * });
   */
  function waitForElement(selector, options = {}) {
    const {
      maxWaitTime = 30000,
      checkInterval = 500,
      checkImmediately = true,
      onFound = null,
      onTimeout = null
    } = options;

    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      
      // Strategy 1: Immediate check
      if (checkImmediately) {
        const existingElement = document.querySelector(selector);
        if (existingElement) {
          console.log(`✅ Element already exists: ${selector}`);
          if (onFound) onFound(existingElement);
          resolve(existingElement);
          return;
        }
      }
      
      // Strategy 2: Polling with timeout
      const pollInterval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
          console.log(`✅ Element found via polling: ${selector}`);
          clearInterval(pollInterval);
          if (onFound) onFound(element);
          resolve(element);
          return;
        }
        
        // Check timeout
        if (Date.now() - startTime > maxWaitTime) {
          console.warn(`⏰ Max wait time exceeded for: ${selector}`);
          clearInterval(pollInterval);
          if (onTimeout) onTimeout();
          reject(new Error(`Element not found within timeout: ${selector}`));
        }
      }, checkInterval);
    });
  }

  /**
   * Wait for an element with a specific attribute value
   * 
   * This function waits for an element to exist AND for its attribute to have a specific value.
   * Uses only polling and timeout - no MutationObserver.
   * Useful when the attribute value changes dynamically (e.g., from "0" to actual value).
   * 
   * @param {string} selector - CSS selector for the element
   * @param {string} attribute - Attribute name to check
   * @param {string|Function} expectedValue - Expected value or function that returns true when value is valid
   * @param {Object} options - Configuration options
   * @returns {Promise<Element>} Promise that resolves with the element when condition is met
   * 
   * @example
   * // Wait for attribute to not be "0"
   * const element = await waitForElementWithAttribute('[data-shiptection-value]', 'data-shiptection-value', 
   *   (value) => value !== "0" && value !== "", 
   *   { maxWaitTime: 15000 }
   * );
   * 
   * // Wait for specific value
   * const element = await waitForElementWithAttribute('[data-shiptection-value]', 'data-shiptection-value', 
   *   "Standard", 
   *   { maxWaitTime: 15000 }
   * );
   */
  function waitForElementWithAttribute(selector, attribute, expectedValue, options = {}) {
    const {
      maxWaitTime = 30000,
      checkInterval = 200,
      checkImmediately = true
    } = options;

    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      
      const checkCondition = () => {
        const element = document.querySelector(selector);
        if (!element) return false;
        
        const currentValue = element.getAttribute(attribute);
        // console.log(`🔍 Checking ${selector} ${attribute}="${currentValue}"`);
        
        // Check if the condition is met
        let isValid = false;
        if (typeof expectedValue === 'function') {
          isValid = expectedValue(currentValue);
        } else {
          isValid = currentValue === expectedValue;
        }
        
        if (isValid) {
          console.log(`✅ Element found with valid ${attribute} value: "${currentValue}"`);
          return true;
        }
        
        return false;
      };
      
      // Strategy 1: Immediate check
      if (checkImmediately && checkCondition()) {
        resolve(document.querySelector(selector));
        return;
      }
      
      // Strategy 2: Polling with timeout
      const pollInterval = setInterval(() => {
        if (checkCondition()) {
          clearInterval(pollInterval);
          resolve(document.querySelector(selector));
          return;
        }
        
        // Check timeout
        if (Date.now() - startTime > maxWaitTime) {
          console.warn(`⏰ Max wait time exceeded for ${selector} with valid ${attribute}`);
          clearInterval(pollInterval);
          reject(new Error(`Element with valid ${attribute} not found within timeout`));
        }
      }, checkInterval);
    });
  }

  /**
   * Wait for shiptection value to be populated with a non-zero value
   * 
   * This is a convenience function specifically for waiting for the shiptection
   * attribute to change from "0" to an actual value.
   * 
   * @param {number} maxWaitTime - Maximum time to wait in milliseconds (default: 15s)
   * @returns {Promise<Element>} Promise that resolves with the element when value is valid
   */
  function waitForShiptectionValue(maxWaitTime = 15000) {
    return waitForElementWithAttribute(
      '[data-shiptection-value]', 
      'data-shiptection-value',
      (value) => value !== "0" && value !== "" && value !== null,
      { 
        maxWaitTime, 
        checkInterval: 200,
        checkImmediately: false
      }
    );
  }

  /**
   * Get shipping protection variant ID by waiting for the shiptection widget and its value
   * 
   * This function handles the common issue where the shiptection widget appears but the
   * data-shiptection-value attribute initially contains "0" and gets updated to the actual
   * value later by the app.
   * 
   * The function:
   * 1. Waits for the .shiptection-widget element to appear
   * 2. Waits for the [data-shiptection-value] attribute to have a valid value (not "0")
   * 3. Fetches product data and finds the matching variant
   * 
   * @returns {Promise<Object|null>} Returns variant data or null if not found
   */
  async function getShippingVariantId(){
    try {
      // Wait for the shiptection widget to appear using the flexible approach
      console.log("🔍 Waiting for shiptection widget to appear...");
      const getShippingEle = await waitForElement('.shiptection-widget', {
        maxWaitTime: 30000,
        checkInterval: 500,
        onFound: (widget) => console.log("🎯 Shiptection widget found:", widget),
        onTimeout: () => console.warn("⏰ Shiptection widget not found within timeout")
      });
      console.log("getShippingEle: ", getShippingEle);
      
      // Now wait for the data attribute to have a valid value (not "0")
      // console.log("🔍 Waiting for shiptection value to be populated (not '0')...");
      const getShippingName = await waitForElementWithAttribute('[data-shiptection-value]', 'data-shiptection-value', 
        (value) => value !== "0" && value !== "" && value !== null, // Wait for any value except "0", "", or null
        { 
          maxWaitTime: 15000,  // 15 seconds max
          checkInterval: 200,  // Check every 200ms
          checkImmediately: false // Don't check immediately since we need the attribute to be populated
        }
      );
      // console.log("getShippingName:", getShippingName);
      
      const shippingValue = getShippingName.getAttribute("data-shiptection-value");
      // console.log("getShippingNameValue:", shippingValue);
      
      if (!shippingValue || shippingValue === "0") {
        // console.log("No valid shipping protection value found (still '0' or empty)");
        return null;
      }
      
      // Fetch product details from Shopify API
      // console.log("Fetching product details for ID: 7571356516567");
      const response = await fetch('https://steelhorseleather.com/products/shiptection-shipping-protection.json');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const product = await response.json();
      // console.log("Product details:", product);
      // console.log("Product variants:", product.product.variants);
      
      // Find variant that matches the shipping protection value
      let matchingVariant = null;
      const allVariants = product.product.variants;
      
      // Format shipping value with dollar sign for display
      const formattedShippingValue = `$${shippingValue}`;
      // console.log("Formatted shipping value:", formattedShippingValue);
      
      // First try to match with variant title
      matchingVariant = allVariants.find(variant => 
        variant.title && variant.title.toLowerCase() === formattedShippingValue
      );
      
      // If no match with title, try with option1 (usually the first option like size, color, etc.)
      if (!matchingVariant) {
        matchingVariant = allVariants.find(variant => 
          variant.option1 && variant.option1.toLowerCase() === formattedShippingValue
        );
      }
      
      if (matchingVariant) {
        document.querySelector('.ajaxcart__switch-toggle-label').textContent = `Shipping Protection (${vela.Currency.formatMoney(matchingVariant.price, vela.strings.moneyFormat)})`;
        // console.log("=== MATCHING VARIANT FOUND ===");
        // console.log("Variant ID:", matchingVariant.id);
        // console.log("Variant Title:", matchingVariant.title);
        // console.log("Option1:", matchingVariant.option1);
        // console.log("Option2:", matchingVariant.option2);
        // console.log("Option3:", matchingVariant.option3);
        // console.log("Price:", matchingVariant.price);
        // console.log("Compare at Price:", matchingVariant.compare_at_price);
        // console.log("Available:", matchingVariant.available);
        
        return {
          variantId: matchingVariant.id,
          variant: matchingVariant
        };
      } else {
        // console.log("=== NO MATCHING VARIANT FOUND ===");
        // console.log("Shipping protection value:", formattedShippingValue);
        // console.log("Available variants:");
        // product.variants.forEach((variant, index) => {
        //   console.log(`Variant ${index + 1}:`, {
        //     id: variant.id,
        //     title: variant.title,
        //     option1: variant.option1,
        //     option2: variant.option2,
        //     option3: variant.option3
        //   });
        // });
        return null;
      }
      
    } catch (error) {
      console.error("Error fetching product details:", error);
      return null;
    }
  }

  destroyToggle = function() {
    const toggleElement = document.querySelector('#shipping-protection-toggle');
    if (toggleElement) {
      // Remove event listener
      toggleElement.removeEventListener('change', handleToggleChange);
      // Remove initialized attribute
      toggleElement.removeAttribute('data-shipping-protection-initialized');
      // Remove loading state
      const container = toggleElement.closest('.ajaxcart__switch-toggle');
      if (container) {
        container.classList.remove('loading');
      }
    }
    shippingProtectionToggle = null;
  };

  module = {
    init: init,
    getShippingVariantId: getShippingVariantId
  }

  return module;
})();

vela.variables = {
  productPageLoad: false,
  productPageSticky: true,
  mediaTablet: 'screen and (max-width: 1024px)',
  mediaMobile: 'screen and (max-width: 767px)',
  isTablet: false,
  isMobile: false
};

vela.initializeEvents = function() {
  var $body = $('body'),
    passwordToggle = '.js-password-toggle',
    scrollToTop = '.js-scroll-to-top',
    collectionSidebarToggle = '.js-sidebar-toggle';
  var classes = {
    passwordShow: 'password-toggle--show'
  };
  $body.on('click', passwordToggle, function(e) {
    e.preventDefault();
    var $this = $(this);
    var $passwordField = $this.siblings('.form-control');
    var isShow = $this.hasClass(classes.passwordShow) ? true : false;
    if (isShow) {
      $this.removeClass(classes.passwordShow);
      $passwordField.attr('type', 'password');
    } else {
      $this.addClass(classes.passwordShow);
      $passwordField.attr('type', 'text');
    }
  });

  $body.on('click', scrollToTop, function(e) {
    e.preventDefault();
    $('body, html').stop().animate({ scrollTop: 0 }, '500');
  });

  $body.on('click', collectionSidebarToggle,function(evt) {
    evt.preventDefault();
    $body.toggleClass('collection-sidebar--open');
  });

  $(window).scroll(function() {
    if ($(window).scrollTop() >= 200) {
      $(scrollToTop).fadeIn();
    } else {
      $(scrollToTop).fadeOut();
    }
  });
};

vela.setBreakpoints = function() {
  enquire.register(vela.variables.mediaTablet, {
    match: function() {
      vela.variables.isTablet = true;
    },
    unmatch: function() {
      vela.variables.isTablet = false;
    }
  });
  enquire.register(vela.variables.mediaMobile, {
    match: function() {
      vela.variables.isMobile = true;
    },
    unmatch: function() {
      vela.variables.isMobile = false;
    }
  });
};

vela.updateSlickSwipe = function(element, allowSwipe){
  if (!element.hasClass('slick-initialized')) {
    return;
  }
  var slickOptions = {
    accessibility: allowSwipe,
    draggable: allowSwipe,
    swipe: allowSwipe,
    touchMove: allowSwipe
  };
  element.slick('slickSetOption', slickOptions, false);
};

vela.showLoading = function () {
  $('body').append(vela.loading != undefined && vela.loading != '' ? vela.loading : '');
};

vela.hideLoading = function() {
  $('.vela-loading').remove();
};

vela.cartInit = function() {
  var $body = $('body');
  if (!vela.cookiesEnabled()) {
    $body.addClass('cart--no-cookies');
  }
  if (vela.settings.cartType == 'modal' || vela.settings.cartType == 'drawer') {
    ajaxCart.init();
    ajaxCart.load();

    if (vela.settings.cartType == 'drawer') {
      vela.drawerCart.init();
      vela.cartUpsellSwiper.init(); // Initialize cart upsell progress bar for drawer cart
    }
  }
};

vela.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'webcookie';
    cookieEnabled = (document.cookie.indexOf('webcookie') !== -1);
  }
  return cookieEnabled;
};

vela.setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + d.toGMTString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

vela.getCookie = function(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(';');
  for(var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === ' ') {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return '';
};

vela.cookieConsent = function() {
  var cConsent = vela.getCookie('cookie_consent'),
    cConsentSelector = $('.cookie-consent'),
    cConsentDismiss = '.cookie-consent-dismiss';
  if (cConsent == 'true') {
    cConsentSelector.remove();
  } else {
    setTimeout(function() {
      cConsentSelector.addClass('active');
    }, 1500);
    if (cConsent == '') vela.setCookie('cookie_consent', false, 365);
  }

  $('body').on('click', cConsentDismiss, function(e) {
    e.preventDefault();
    cConsentSelector.remove();
    vela.setCookie('cookie_consent', true, 365);
  });
};

vela.slideshow = function() {
  var slideshow = '.js-vela-slideshow',
    fade = $(slideshow).data('fade'),
    autoplay = $(slideshow).data('autoplay'),
    autoplayInterval = $(slideshow).data('autoplayinterval'),
    autoplayNavigation = $(slideshow).data('navigation'),
    autoplayPagination = $(slideshow).data('pagination');

  var config = {
    fade: true,
    rows: 0,
    arrows: autoplayNavigation,
    autoplay: autoplay,
    autoplaySpeed: autoplayInterval
  };

  (fade === undefined || fade == null) ? true : config.fade = fade;
  (autoplayInterval === undefined || autoplayInterval == null) ? true : config.autoplaySpeed = autoplayInterval;
  (autoplayPagination === undefined || autoplayPagination == null || autoplayPagination != true) ? config.dots = false : config.dots = true;

  $(slideshow).slick(config);
};

vela.slickCarousel = function() {
  var velCarousel = '.js-carousel';
  $(velCarousel).each(function() {
    var $element = $(this),
      nav = $element.data('nav'),
      dots = $element.data('dots'),
      center = $element.data('center'),
      infinite = $element.data('infinite'),
      autoplay = $element.data('autoplay'),
      autoplaySpeed = $element.data('autoplayspeed'),
      speedSlide = $element.data('speedslide'),
      columnone = $element.data('columnone'),
      columntwo = $element.data('columntwo'),
      columnthree = $element.data('columnthree'),
      columnfour = $element.data('columnfour'),
      rows = $element.data('rows');
    var config = {
      swipeToSlide: true,
      arrows: nav,
      slidesToShow: columnone,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: columntwo
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: columnthree
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: columnfour
          }
        }
      ]
    };
    (center === undefined || center == null || center != true) ? config.centerMode = false : config.centerMode = true;
    (dots === undefined || dots == null || dots != true) ? config.dots = false : config.dots = true;
    (infinite === undefined || infinite == null || infinite != true) ? config.infinite = false : config.infinite = true;
    (infinite === undefined || infinite == null || infinite != true) ? config.infinite = false : config.infinite = true;
    (speedSlide === undefined || speedSlide == null) ? config.speed = '300' : config.speed = speedSlide;
    if (autoplay) {
      config.autoplay = autoplay;
      config.autoplaySpeed = autoplaySpeed;
      config.cssEase = "linear";
    }
    if (rows !== undefined && rows != null && rows != 1) {
      config.rows = rows;
      config.slidesPerRow = columnone;
      config.slidesToShow = 1,
      config.responsive = [
        {
          breakpoint: 992,
          settings: {
            slidesPerRow: columntwo,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesPerRow: columnthree,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesPerRow: columnfour,
            slidesToShow: 1
          }
        }
      ]
    } else {
      config.rows = 0;
    }
    $element.slick(config);
  });

  $('.product-tabs__nav-link').on('shown.bs.tab', function() {
    var productTabs = $(this).closest('.product-tabs');
    if (productTabs.find(velCarousel).length > 0) {
      productTabs.find(velCarousel).slick('setPosition');
    }
  });
};

vela.countdown = function() {
  var countdown = '[data-countdown]';
  $(countdown).each(function() {
    var $this = $(this),
      finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      var strTime = '<div class="countdown__item"><span>%D</span><span>' + vela.strings.countdownDays + '</span></div>' +
        '<div class="countdown__item"><span>%H</span><span>' + vela.strings.countdownHours + '</span></div>' +
        '<div class="countdown__item"><span>%M</span><span>' + vela.strings.countdownMinutes + '</span></div>' +
        '<div class="countdown__item"><span>%S</span><span>' + vela.strings.countdownSeconds + '</span></div>';
      $this.html(event.strftime(strTime));
    })
    .on('finish.countdown', function() {
      $this.html(vela.strings.countdownFinish);
    });
  });
};

vela.newsletter = function() {
  var alertNewsletter;
  $('.js-vela-newsletter').each(function() {
    var $form = $(this);
    $form.on('submit', function(event) {
      event.preventDefault();
      $('.js-alert-newsletter').remove();
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          if (data.result === 'success') {
            $form.prepend(alertNewsletter(vela.strings.newsletterSuccess ,'success'));
            $('.js-input-newsletter').val('');
          } else {
            $form.prepend(alertNewsletter(data.msg.replace('0 - ', '') ,'danger'));
          }
        },
        error: function(err) {
          $form.prepend(alertNewsletter(err ,'danger'));
        }
      });
    });
  });
  alertNewsletter = function(message, type) {
    var alert = '<div class="js-alert-newsletter alert-dismissible fade show alert alert--mailchimp alert-' + type + '">' + message + ' <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>';
    return alert;
  };
  var newsletterPopup = '.js-newsletter-popup',
    newsletterPopupClose = '.js-newsletter-popup-close',
    newsletterPopupSubmit = '.js-newsletter-popup-submit',
    cNewsletter = '',
    classNameNewsletterActive = 'newsletter-popup--active';
  if ($(newsletterPopup).find('.js-newsletter-popup-success').length > 0) {
    vela.setCookie('vela_newsletter_popup', 1, 30);
  }
  cNewsletter = vela.getCookie('vela_newsletter_popup');
  if (cNewsletter == 1) $(newsletterPopup).remove();

  if (cNewsletter != 1 && !($('.shopify-challenge__container').length > 0)) {
    setTimeout(function() {
      $(newsletterPopup).addClass(classNameNewsletterActive);
    }, 5000);
  }
  $(newsletterPopupClose).on('click', function() {
    if ($(newsletterPopup).find('.alert--mailchimp').length > 0) {
      vela.setCookie('vela_newsletter_popup', 1, 30);
    } else {
      vela.setCookie('vela_newsletter_popup', 1, 1);
    }
    $(newsletterPopup).removeClass(classNameNewsletterActive);
  });

  $(newsletterPopupSubmit).on('click', function() {
    vela.setCookie('vela_newsletter_popup', 1, 30);
  });
};
vela.velaBannerTop = function () {
  cBannerTop = vela.getCookie('velaBannerTop');
  if (cBannerTop == 1) $('#bannerTop').remove();
  $('#bannerTop .btn-bannerTop').on('click', function() {
    vela.setCookie('velaBannerTop', 1, 30);
    $('#bannerTop').remove();
  });
};
vela.swatchProduct = function() {
  $('.product-card__swatch--list .more_option').on( "click", function() {
    $(this).toggleClass('more_option_active');
    $(this).parent().find('.extendlink').toggleClass('more_option_item');
  });
	$( ".product-card__swatch--list > li" ).click(function() {
    $(this).parent('.product-card__swatch--list').find('li').removeClass('is-active');
    $(this).addClass('is-active');
    var newImageSrc = $(this).find('.d-none img').attr('src');
    var newImageSrcset = $(this).find('.d-none img').attr('srcset');
    if (newImageSrc != 'undefined'){
        $(this).parents('.product-grid__inner').find('.product-card__img-primary img').attr({
            src: newImageSrc
        });
    }
    if (newImageSrcset != 'undefined'){
      $(this).parents('.product-grid__inner').find('.product-card__img-primary img').attr({
          srcset: newImageSrcset
      });
    }
    return false;
  });
}
vela.customNumberInput = function() {
  var $body = $('body'),
    qtyAdjust = '.js-qty-adjust',
    qtyNumber = '.js-qty-number';

  var validateQty;

  $body.on('click', qtyAdjust, function() {
    var $el = $(this),
      $qtySelector = $el.siblings(qtyNumber),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    qty = validateQty(qty);

    if ($el.hasClass('vela-qty__adjust--plus')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
      if (qty <= 0 && $qtySelector.attr('min') == '1') qty = 1;
    }

    $qtySelector.val(qty);
  });

  $body.on('focus', qtyAdjust, function() {
    var $el = $(this);
    setTimeout(function() {
      $el.select();
    }, 50);
  });

  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      qty = 1;
    }
    return qty;
  };
};

vela.preLoading = function() {
  if (vela.settings.enablePreLoading) {
    var counter = 0,
      preLoading = '#pre-loading',
      preLoadingBar = '.pre-loading__bar',
      items = new Array();

    $(preLoading).css({
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 99999,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 1)'
    });

    function getImages(element) {
      $(element).find('*:not(script)').each(function() {
        var url = '';
        if ($(this).css('background-image') != '' &&
          $(this).css('background-image').indexOf('none') == -1 &&
          $(this).css('background-image').indexOf('-gradient') == -1) {
          url = $(this).css('background-image');
          if(url.indexOf('url') != -1) {
            var temp = url.match(/url\((.*?)\)/);
            url = temp[1].replace(/\"/g, '');
          }
        } else if ($(this).get(0).nodeName.toLowerCase() == 'img' && typeof($(this).attr('src')) != 'undefined') {
          url = $(this).attr('src');
        }

        if (url.length > 0 && items.length < 1) {
          items.push(url);
        }
      });
    }

    function runPreLoading() {
      counter++;
      var per = Math.round((counter / items.length) * 100);
      $(preLoadingBar).stop().animate({
          width: per + '%'
      }, 200, 'linear');
      if(counter >= items.length) {
        counter = items.length;
        $(preLoadingBar).stop().animate({
          width: '100%'
        }, 200, 'linear', function() {
          $(preLoading).fadeOut(200, function() {
            $(preLoading).remove();
          });
        }); 
      }
    }

    function preLoadingImage(url) {
      var imgPreLoading = new Image();
      $(imgPreLoading).on('load', function() {
        runPreLoading();
      }).on('error', function() {
        runPreLoading();
      }).attr('src', url);
    }

    function preLoadingStart() {
      if(items.length > 0 ){
        for (var i = 0; i < items.length; i++) {
          preLoadingImage(items[i]);
        }
      } else  {
        $(preLoadingBar).stop().animate({
          width: '100%'
        }, 200, 'linear', function() {
          $(preLoading).fadeOut(200, function() {
            $(preLoading).remove();
          });
        }); 
      }
    }
    getImages('body');
    preLoadingStart();
  }
};
vela.productLoadMore = function () {
  function loadmoreExecute() {
      var velaLoadNode = $('.sectioin-product-more .product-more__btn');
      var velaLoadUrl = $('.sectioin-product-more .product-more__btn').attr("href");
      $.ajax({
          type: 'GET',
          url: velaLoadUrl,
          beforeSend: function() {
            $('.sectioin-product-more .pre-loading').removeClass('d-none');
          },
          success: function(data) {
              velaLoadNode.remove();
              var filteredData = $(data).find(".product-more__content");
              filteredData.insertBefore($(".product-more__bottom"));
              btnMoreEvent();
              updateToolTip();
          },
          dataType: "html"
      });
  }
  function btnMoreEvent(){
      $('.sectioin-product-more .product-more__btn').click(function(e){
          if ($(this).hasClass('disableLoadMore')) {
              e.stopPropagation();
              return false;
          }
          else {
              loadmoreExecute();
              e.stopPropagation();
              return false;
          }
      });
  }
  function updateToolTip(){
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
  }
  btnMoreEvent();
};
vela.accordion = function(){
  function accordionFooter(){
      if ( $(window).width() < 768 ){
          if(!$('.accordion-footer').hasClass('accordion')){
              $('.accordion-footer .footer__title').on('click', function(e){
                  $(this).toggleClass('active').parent().find('.accordion-footer__content').stop().slideToggle('medium');
                  e.preventDefault();
              });
              $('.accordion-footer').addClass('accordion').find('.accordion-footer__content').slideUp('fast');
          }
      }
      else {
          $('.accordion-footer .footer__title').removeClass('active').off().parent().find('.accordion-footer__content').removeAttr('style').slideDown('fast');
          $('.accordion-footer').removeClass('accordion');
      }
  }
  accordionFooter();
  $(window).resize(accordionFooter);
};
vela.gallery = function(){
  $('.gallery-image').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true
    }
  });
};

// Custom Add to Cart functionality
/**
 * Global function to get shipping protection variant ID
 * 
 * This function reads the shipping protection value from the widget and finds
 * the matching variant from product ID 7571356516567.
 * 
 * @returns {Promise<Object|null>} Returns an object with variantId and variant details, or null if no match
 * @returns {number} .variantId - The Shopify variant ID
 * @returns {Object} .variant - Full variant object with all properties
 * 
 * Example:
 * const result = await vela.getShippingProtectionVariant();
 * if (result) {
 *   console.log('Variant ID:', result.variantId);
 *   console.log('Variant Title:', result.variant.title);
 *   console.log('Price:', result.variant.price);
 * }
 */
vela.getShippingProtectionVariant = async function() {
  if (vela.shippingProtectionToggle && vela.shippingProtectionToggle.getShippingVariantId) {
    return await vela.shippingProtectionToggle.getShippingVariantId();
  } else {
    console.warn("Shipping protection toggle module not available");
    return null;
  }
};

/**
 * Demo function to test shipping protection variant matching
 * 
 * This function demonstrates how to use the shipping protection variant matching.
 * It will:
 * 1. Read the shipping protection value from the widget
 * 2. Fetch product details for product ID 7571356516567
 * 3. Compare variant titles and options with the shipping value
 * 4. Return the matching variant ID and details
 * 
 * Usage:
 * - Call this function to test: vela.testShippingProtectionVariant()
 * - Get variant data: vela.getShippingProtectionVariant()
 * 
 * Example:
 * const variantData = await vela.getShippingProtectionVariant();
 * if (variantData) {
 *   console.log('Variant ID:', variantData.variantId);
 *   // Use variantData.variant for other operations
 * }
 */
vela.testShippingProtectionVariant = async function() {
  console.log("=== TESTING SHIPPING PROTECTION VARIANT MATCHING ===");
  
  try {
    const result = await vela.getShippingProtectionVariant();
    
    if (result) {
      console.log("✅ SUCCESS: Found matching variant!");
      console.log("Variant ID:", result.variantId);
      console.log("Variant Details:", result.variant);
      
      // You can now use this variant ID for other operations
      // For example, to add it to cart:
      // vela.addShippingProtectionToCart(result.variantId);
      
    } else {
      console.log("❌ No matching variant found");
      console.log("Check the console logs above for detailed variant information");
    }
    
  } catch (error) {
    console.error("❌ Error testing shipping protection variant:", error);
  }
};

vela.customAddToCart = function() {
  // Handle custom add-to-cart click
  function handleCustomAddToCart(event) {
    const btn = document.querySelector('.custom-add-to-cart');
    console.log("Custom add-to-cart button clicked:", btn);
    
    // Find the closest product section to get the section ID
    const getSelectId = document.querySelector('[data-select-id]');
    const sectionId = getSelectId.getAttribute('data-select-id');
    
    const variantSelect = document.querySelector('.custom-js-product-select--' + sectionId);
    if (!variantSelect) {
      console.log("Variant select not found for section:", sectionId);
      return;
    }
  
    const variantId = variantSelect.value;
    console.log("Variant ID:", variantId);
  
    // Disable button while processing
    btn.disabled = true;
    btn.classList.add('loading');
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      // Update cart count and price
      if (typeof vela.updateCountPrice === 'function') {
        vela.updateCountPrice(cart);
      }
      
      // Build cart contents
      if (typeof vela.buildCart === 'function') {
        vela.buildCart(cart);
      }
      
      // Open cart drawer
      $('body').trigger('drawer.open');
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      alert('There was an issue adding the product to cart.');
    })
    .finally(() => {
      btn.disabled = false;
      btn.classList.remove('loading');
      
      // Use existing cart update methods
      if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function') {
        ShopifyAPI.getCart(function(cart, added) {
          if (typeof vela.cartUpdateCallback === 'function') {
            vela.cartUpdateCallback(cart, true);
          }
        }, true);
      }
    });
  }

  // Use event delegation to handle dynamically added elements
  document.addEventListener('click', function(event) {
    if (event.target.closest('.custom-add-to-cart')) {
      handleCustomAddToCart(event);
    }
  });

  // Also attach listeners to existing elements on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-add-to-cart').forEach(function (btn) {
      console.log("Found custom add-to-cart button:", btn);
      // Remove any existing listeners to prevent duplicates
      btn.removeEventListener('click', handleCustomAddToCart);
      // Add new listener
      btn.addEventListener('click', handleCustomAddToCart);
    });
  });

  // Use MutationObserver to handle dynamically added elements
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              const customButtons = node.querySelectorAll ? node.querySelectorAll('.custom-add-to-cart') : [];
              if (node.classList && node.classList.contains('custom-add-to-cart')) {
                customButtons.push(node);
              }
              customButtons.forEach(function(btn) {
                console.log("Found dynamically added custom add-to-cart button:", btn);
                btn.removeEventListener('click', handleCustomAddToCart);
                btn.addEventListener('click', handleCustomAddToCart);
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

vela.init = function() {
  vela.preLoading();
  vela.initializeEvents();
  vela.setBreakpoints();
  if(!$('body').hasClass('template-cart')) {
    vela.cartInit();
  }
  
  // Check initial cart state and hide footer if empty
  if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function') {
    ShopifyAPI.getCart(function(cart) {
      if (cart.item_count === 0) {
        $('.drawer__footer').css({opacity: 0, visibility: 'hidden'});
      }
    });
  }
  
  vela.slideshow();
  vela.slickCarousel();
  vela.countdown();
  vela.cookieConsent();
  vela.newsletter();
  vela.customNumberInput();
  vela.accordion();
  vela.gallery();
  vela.productLoadMore();
  vela.velaBannerTop();
  vela.swatchProduct();
  vela.customAddToCart(); // Add the new custom add-to-cart functionality
  vela.cartUpsellSwiper.init(); // Initialize cart upsell progress bar
  vela.shippingProtectionToggle.init(); // Initialize shipping protection toggle
  if (vela.cartUpsellProducts && vela.cartUpsellProducts.init) {
    vela.cartUpsellProducts.init(); // Initialize cart upsell products manager
  }
  if (vela.settings.enableQuickView) {
    new vela.QuickView('.js-quickview');
  }
};

$(document).ready(function() {
  vela.init();
  var sections = new vela.Sections();
});

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});
